import { NotFoundPage } from '@/features/errors/NotFoundPage'

/**
 * Router'ın 404 bileşeni. İçerik `features/errors` altındaki ortak iskeletten gelir ki
 * 404, 403 ve bakım ekranları aynı dili konuşsun (C6).
 */
export function NotFound() {
  return <NotFoundPage />
}
